<template>
  <BaseBookingCard
    :disable-submit="disabled"
    @submit="confirmBooking()"
  >
    <div class="form-group">
      <label for="PtaFormStage" class="font-weight-bold text-dark d-block">{{ $t('Stage:') }}</label>
      <Select2 :model-value="stageId"
               @update:model-value="selectStage($event)"
               class="w-100"
               id="PtaFormStage"
               :options="props.stages.map((stage) => ({
                  ...stage,
                  text: stage.name,
               }))"
               :select2Options="{
                    templateResult: formatStageTemplate(stage),
               }"
               v-cloak>
      </Select2>
    </div>

    <FormSlot
      :stage="selectedStage"
      :product="product"
      :url-availability="urlAvailability"
      @slot-change="onSlotChange"
      @find-equipment="onFindEquipment"
    >
    </FormSlot>
  </BaseBookingCard>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Select2 from "@/components/frontend/ui/Select2.vue";
import FormSlot from "@/components/frontend/booking/slot/Form.vue";
import BaseBookingCard from "@/components/frontend/booking/BookingCard.vue";
import { formatStageTemplate } from "@/utils/stage";

const props = defineProps({
  product: {
    type: Object,
    required: true
  },
  equipments: {
    type: Array,
    default : () => []
  },
  stages: {
    type: Array,
    default : () => []
  },
  urlAvailability: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const equipment = ref(undefined);
const selectedStage = ref(undefined);
const slot = ref(undefined);

const stageId = computed(() => selectedStage.value ? selectedStage.value.id : null);

const selectStage = (stageId) => {
  selectedStage.value = props.stages.find((stage) => stage.id === parseInt(stageId));
};

const onSlotChange = (slotId) => {
  slot.value = slotId;
}

const onFindEquipment = (equipmentSelected) => {
  equipment.value = equipmentSelected;
}

const emit = defineEmits(['submit-booking']);

const confirmBooking = () => {
  emit('submit-booking', {
    slot: slot.value,
    equipment: equipment.value
  });
}

onMounted(() => {
  if (props.stages.length === 1) {
    selectedStage.value = props.stages[0];
  }
})
</script>